var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 10,
    viewBox: "0 0 22 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.03,0.27 L7.8,8.016 C8.5994075,8.81895549 8.5994075,10.1170445 7.8,10.92 L0,18.93",
    strokeWidth: 1.5,
    transform: "translate(-709.000000, -756.000000) translate(705.000000, 746.000000) translate(15.100000, 15.300000) rotate(90.000000) translate(-15.100000, -15.300000) translate(10.600001, 5.800000)",
    stroke: "currentColor",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.5e01e5fb2ff1164afe8f2ecfcf207abd.svg";
export { ForwardRef as ReactComponent };